import styled from 'styled-components';
import { key } from 'styled-theme';

import { TooltipStyledProps } from '../types';

const arrow = 15;
const arrowFix = '-5px;';

export default styled.span`
  .ra-tooltip {
    background: ${key('colors.white')};
    border: none;
    border-radius: ${key('sizes.borderRadius')};
    box-shadow: ${key('outlines.shadow.default')};
    z-index: 99;
    margin-top: -2px;

    .ra-tooltip-message {
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      padding: 10px 20px;

      p {
        padding: 0;
        color: ${(props: TooltipStyledProps) => {
          if (props.success) return props.theme.states.success.default;
          if (props.danger) return props.theme.states.danger.default;
          if (props.warning) return props.theme.states.warning.default;

          return props.theme.text.primary;
        }};
      }

      &:after {
        border-width: ${arrow}px;
      }
    }

    &.top {
      top: -5px;

      .ra-tooltip-message:after {
        border-top-color: ${key('colors.white')};
        margin-top: ${arrowFix};
        margin-left: -${arrow}px;
      }
    }

    &.right {
      right: -${arrow}px;

      .ra-tooltip-message:after {
        border-right-color: ${key('colors.white')};
        margin-right: ${arrowFix};
        margin-top: -${arrow}px;
      }
    }

    &.bottom {
      bottom: -5px;

      .ra-tooltip-message:after {
        border-bottom-color: ${key('colors.white')};
        margin-bottom: ${arrowFix};
        margin-left: -${arrow}px;
      }
    }

    &.left {
      left: -${arrow}px;

      .ra-tooltip-message:after {
        border-left-color: ${key('colors.white')};
        margin-left: ${arrowFix}
        margin-top: -${arrow}px;
      }
    }
  }
`;
